import React, { act, useEffect, useState } from 'react'
import Topbar from '../components/Topbar'
import Leftbar from '../components/Leftbar'
import { Link } from 'react-router-dom'
import {
  displayError,
  displaySuccess,
  getCoupons,
  getNriProviders,
  getNriUsers,
  getPendingReviewList,
  getPhyios,
  getPositiveReviews,
  getReschedules,
  getReviewsList,
  sendReminder,
  updateReview
} from '../Utils/utils'
import { toggleLoader } from '../actions/loader'
import { connect } from 'react-redux'
import SweetAlert from 'react-bootstrap-sweetalert'
import config from '../config/config'
import axios from 'axios'
import ReactPaginate from 'react-paginate'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import TimePicker from 'react-time-picker'
import moment from 'moment'
import DatePicker from 'react-datepicker'

const ReviewList = props => {
  const [users, setUsers] = useState([])
  const [is_delete, setIsDelete] = useState('')
  const [temp_var_id, setTempVarId] = useState('')
  const [count, setCount] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [page, setPage] = useState(1)
  const [show, setShow] = useState(false)
  const [fromTime, setFromTime] = useState(moment(new Date()).format('HH:mm'))
  const [toTime, setToTime] = useState(moment(new Date()).format('HH:mm'))
  const handleClose = () => setShow(false)
  const [fromDate, setFromDate] = useState(new Date())
  const [selectedReview, setSelectedReview] = useState(null)
  const [isRecommended, setIsRecommended] = useState(null)
  const [politeness, setPoliteness] = useState(0)
  const [timeRating, setTimeRating] = useState(0)
  const [skillRating, setSkillRating] = useState(0)
  const [overallRating, setOverallRating] = useState(0)
  const [reviewText, setReviewText] = useState('')
  const [activePage, setActivePage] = useState(0)
  const TABS = {
    PENDING: 'pending',
    BAD: 'negative',
    POSITIVE: 'positive'
  }
  const [activeTab, setActiveTab] = useState(TABS.PENDING)
  const normalizeUsers = data => {
    if (Array.isArray(data)) return data
    if (Array.isArray(data?.data)) return data.data
    if (Array.isArray(data)) return data
    return []
  }
  const fetchReviews = async (pageNo = 1, tab = activeTab) => {
    props.toggleLoader(true)
    setUsers([])
    let response
    try {
      switch (tab) {
        case TABS.BAD:
          response = await getReviewsList(count, pageNo)
          break
        case TABS.POSITIVE:
          response = await getPositiveReviews(count, pageNo)
          break
        default:
          response = await getPendingReviewList(count, pageNo)
      }
      setUsers(normalizeUsers(response?.data))
      const totalPages =
        response?.metadata?.totalPage ||
        response?.data?.metadata?.totalPage ||
        0
      setPage(totalPages)
      setActivePage(pageNo)
    } catch (err) {
      displayError('Failed to load reviews')
      setUsers([])
    }
    props.toggleLoader(false)
  }
  useEffect(() => {
    fetchReviews(1, activeTab)
  }, [activeTab])
  // console.log('users', users)
  const openEditModal = review => {
    setSelectedReview(review)

    setPoliteness(review?.politeness || 0)
    setTimeRating(review?.time_management || 0)
    setSkillRating(review?.skills || 0)
    setOverallRating(review?.rating || 0)
    setReviewText(review?.review || '')
    setIsRecommended(review?.is_recommended)
    setShowModal(true)
  }
  const renderStars = rating => {
    return (
      <>
        {[1, 2, 3, 4, 5].map(i => (
          <i
            key={i}
            className={`fa fa-star ${
              i <= rating ? 'text-warning' : 'text-muted'
            }`}
          />
        ))}
      </>
    )
  }
  const submitEditReview = async () => {
    const payload = {
      user_id: selectedReview?.user_id,
      rating_id: selectedReview?._id,
      provider_id: selectedReview?.provider?._id,
      nri_booking_id: selectedReview?.nri_booking_id,
      nri_booking_slot_id: selectedReview?.nri_booking_slot_id,
      rating: overallRating,
      review: reviewText,
      politeness: politeness,
      time_management: timeRating,
      skills: skillRating,
      is_recommended: isRecommended
    }
    var getUsers_var = await updateReview(payload)
    if (getUsers_var?.status == 200) {
      displaySuccess(getUsers_var?.message)
      setShowModal(false)
      // getListNew()
    } else {
      displayError(getUsers_var?.message)
    }
  }

  const images = [
    { mark: 1, default: '/img/verybad.png', selected: '/img/reaction5.png' },
    { mark: 2, default: '/img/bad.png', selected: '/img/reaction4.png' },
    { mark: 3, default: '/img/okok.png', selected: '/img/reaction3.png' },
    { mark: 4, default: '/img/good.png', selected: '/img/reaction2.png' },
    { mark: 5, default: '/img/happy.png', selected: '/img/reaction1.png' }
  ]
  const handlePageClick = async e => {
    const selectedPage = e.selected + 1
    fetchReviews(selectedPage, activeTab)
  }

  const sendReminderApi = async (booking, provider, slot_id) => {
    var response = await sendReminder(booking, provider, slot_id)
    if (response?.data?.status === 200) {
      displaySuccess(response?.data?.message)
    } else {
      displayError(response?.data?.message)
    }
  }

  return (
    <>
      <body className='g-sidenav-show bg-gray-100'>
        <div id='wrapper'>
          <Leftbar />

          <main className='main-content border-radius-lg'>
            <Topbar />

            {/* HEADER */}
            <div className='header bg-primary pb-6'>
              <div className='container-fluid'>
                <div className='header-body'>
                  <div className='row align-items-center py-4'>
                    <div className='col-lg-6 col-7'>
                      <nav className='breadcrumb breadcrumb-links breadcrumb-dark'>
                        <Link to='/dashboard-nri' className='breadcrumb-item'>
                          <i className='fas fa-home' />
                        </Link>
                        <span className='breadcrumb-item active'>
                          Reviews List
                        </span>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className='container-fluid mt--6'>
              <div className='card'>
                <div className='card-header border-0'>
                  <h3 className='mb-0'>Reviews</h3>
                </div>

                {/* ================= TABS ================= */}
                <ul className='nav nav-tabs px-3'>
                  <li className='nav-item'>
                    <button
                      className={`nav-link ${
                        activeTab === 'pending' ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab('pending')}
                    >
                      Pending Reviews
                    </button>
                  </li>

                  <li className='nav-item'>
                    <button
                      className={`nav-link ${
                        activeTab === TABS.BAD ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab(TABS.BAD)}
                    >
                      Negative Reviews
                    </button>
                  </li>

                  <li className='nav-item'>
                    <button
                      className={`nav-link ${
                        activeTab === 'positive' ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab('positive')}
                    >
                      Positive Reviews
                    </button>
                  </li>
                </ul>

                {/* ================= TAB CONTENT ================= */}
                <div className='card-body p-0'>
                  {/* ===== PENDING REVIEWS TAB ===== */}
                  {activeTab === 'pending' && (
                    <>
                      <div className='table-responsive'>
                        <table className='table align-items-center table-flush'>
                          <thead className='thead-light'>
                            <tr>
                              <th>Booking No.</th>
                              <th>Session</th>
                              <th>User</th>
                              <th>Patient</th>
                              <th>Provider</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {users?.map(user => (
                              <tr key={user._id}>
                               
                                <td><b>{user?.nri_booking?.booking_number}</b></td>
                                <td>{user?._id}</td>
                                <td>{user?.user?.full_name}</td>
                                <td>{user?.nri_booking?.member?.full_name}</td>
                                <td>{user?.provider?.name}</td>
                                <td>
                                  <button
                                    className='btn btn-primary btn-sm'
                                    onClick={() =>
                                      sendReminderApi(
                                        user.nri_booking_id,
                                        user.provider._id,
                                        user._id
                                      )
                                    }
                                  >
                                    Remind for Review
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {users?.length > 0 ? (
                        <Row>
                          <Col xs={12}>
                            <div className='paginate-css'>
                              <ReactPaginate
                                previousLabel='<'
                                nextLabel='>'
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={page}
                                marginPagesDisplayed={0}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                // subContainerClassName={"pages pagination"}
                                activeClassName={'active'}
                                forcePage={activePage - 1}
                              />
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        // <ReactPaginate
                        //   previousLabel='<'
                        //   nextLabel='>'
                        //   pageCount={page}
                        //   onPageChange={handlePageClick}
                        //   containerClassName='pagination'
                        //   activeClassName='active'
                        // />
                        <center>
                          <h4>No Reviews</h4>
                        </center>
                      )}
                    </>
                  )}

                  {/* ===== NEGATIVE REVIEWS TAB ===== */}
                  {activeTab === 'negative' && (
                    <>
                      <div className='table-responsive'>
                        <table className='table align-items-center table-flush'>
                          <thead className='thead-light'>
                            <tr>
                              <th>User</th>
                              <th>Phone Number</th>
                              <th>Provider</th>
                              <th>Rating</th>
                              <th>Review</th>
                              <th>Date</th>
                              <th>Session</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {users?.map(review => (
                              <tr key={review._id}>
                                <td>
                                  <b>{review?.user?.full_name}</b>
                                </td>
                                <td>{review?.provider?.phone_number}</td>
                                <td>{review?.provider?.name}</td>
                                <td>
                                  {renderStars(
                                    review?.rating || 0
                                  )}
                                </td>
                                <td style={{ maxWidth: 300 }}>
                                  {review?.review}
                                </td>
                                
                                <td>{moment(review?.nri_booking_slot?.date).format(
                                                                        'DD-MM-YYYY'
                                                                      )}</td>
                                <td>{review?.nri_booking_slot_id}</td>

                                <td>
                                  <button
                                    className='btn btn-sm btn-primary'
                                    onClick={() => openEditModal(review)}
                                  >
                                    Edit
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {users?.length > 0 ? (
                        <Row>
                          <Col xs={12}>
                            <div className='paginate-css'>
                              <ReactPaginate
                                previousLabel='<'
                                nextLabel='>'
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={page}
                                marginPagesDisplayed={0}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                // subContainerClassName={"pages pagination"}
                                activeClassName={'active'}
                                forcePage={activePage - 1}
                              />
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <center>
                          <h4>No Negative Reviews</h4>
                        </center>
                      )}
                    </>
                  )}

                  {/* ===== POSITIVE REVIEWS TAB ===== */}
                  {activeTab === 'positive' && (
                    <>
                      <div className='table-responsive'>
                        <table className='table align-items-center table-flush'>
                          <thead className='thead-light'>
                            <tr>
                              <th>User</th>
                              <th>Provider</th>
                              <th>Review</th>
                            </tr>
                          </thead>

                          <tbody>
                            {users?.map(user => (
                              <tr key={user._id}>
                                <td>{user?.user?.full_name}</td>
                                <td>{user?.provider?.name}</td>
                                <td>{user?.review}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {users?.length > 0 ? (
                        <Row>
                          <Col xs={12}>
                            <div className='paginate-css'>
                              <ReactPaginate
                                previousLabel='<'
                                nextLabel='>'
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={page}
                                marginPagesDisplayed={0}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                // subContainerClassName={"pages pagination"}
                                activeClassName={'active'}
                                forcePage={activePage - 1}
                              />
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <center>
                          <h4>No Reviews</h4>
                        </center>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* ===== EDIT MODAL (NEGATIVE TAB ONLY) ===== */}
            {showModal && (
              <div className='modal-backdrop-custom'>
                <div className='modal-box'>
                  <div className='modal-header'>
                    <h4>Edit Review</h4>
                    <button onClick={() => setShowModal(false)}>✕</button>
                  </div>

                  <p className='modal-title'>Provider’s behavior</p>
                  <div className='rating-row'>
                    {images.map((img, index) => (
                      <img
                        key={index}
                        src={
                          politeness === img.mark ? img.selected : img.default
                        }
                        className='emoji'
                        onClick={() => setPoliteness(img.mark)}
                        alt=''
                      />
                    ))}
                  </div>

                  <p className='modal-title'>Time management</p>
                  <div className='rating-row'>
                    {[1, 2, 3, 4, 5].map(i => (
                      <span
                        key={i}
                        className={`star ${i <= timeRating ? 'active' : ''}`}
                        onClick={() => setTimeRating(i)}
                      >
                        ★
                      </span>
                    ))}
                  </div>

                  {/* Skill Level */}
                  <p className='modal-title'>Skill Level</p>
                  <div className='rating-row'>
                    {[1, 2, 3, 4, 5].map(i => (
                      <span
                        key={i}
                        className={`star ${i <= skillRating ? 'active' : ''}`}
                        onClick={() => setSkillRating(i)}
                      >
                        ★
                      </span>
                    ))}
                  </div>

                  <p className='modal-title'>Overall Rating</p>
                  <div className='rating-row'>
                    {[1, 2, 3, 4, 5].map(i => (
                      <span
                        key={i}
                        className={`star ${i <= overallRating ? 'active' : ''}`}
                        onClick={() => setOverallRating(i)}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                  <p className='modal-title'>
                    Would you recommend this provider?
                  </p>

                  <div className='radio-group'>
                    <label className='radio-label'>
                      <input
                        type='radio'
                        name='is_recommended'
                        value='yes'
                        checked={isRecommended === true}
                        onChange={() => setIsRecommended(true)}
                      />
                      Yes
                    </label>

                    <label className='radio-label'>
                      <input
                        type='radio'
                        name='is_recommended'
                        value='no'
                        checked={isRecommended === false}
                        onChange={() => setIsRecommended(false)}
                      />
                      No
                    </label>
                  </div>
                  <textarea
                    className='review-input'
                    placeholder='Write your review'
                    value={reviewText}
                    onChange={e => setReviewText(e.target.value)}
                  />

                  <div className='modal-footer'>
                    <button
                      className='btn-secondary'
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button className='btn-primary' onClick={submitEditReview}>
                      Update
                    </button>
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </body>
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = state => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(ReviewList)
